import { useMemo, type ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import type { NaveSessionBootstrap } from "../../read-models/identity/nave-session-bootstrap";
import { productionCustomerClient } from "../../composition/production-customer-client";
import { createProductionCustomerRuntime } from "../../composition/production-customer-runtime";
import { AccountsExperienceContextProvider } from "../auth/AccountsExperienceProvider";
import { CustomerRuntimeProvider } from "../scenario/ScenarioProvider";
import type { OrganizationId } from "../../shared/identifiers/ids";

export const RealAppProviders = ({ session, logout, selectOrganization, selectClient, switching, switchError, children }: {
  session: NaveSessionBootstrap; logout(): Promise<void>; selectOrganization(id: string): Promise<void>;
  selectClient(id:string):Promise<void>; switching: boolean; switchError: boolean; children?: ReactNode;
}) => {
  const runtime = useMemo(() => createProductionCustomerRuntime(session, productionCustomerClient), [session]);
  const select = (id: OrganizationId) => { void selectOrganization(id.value); };
  return <BrowserRouter><CustomerRuntimeProvider key={`${session.activeOrganization?.id}:${session.activeClient?.id ?? "none"}` } value={{
    runtime, activeOrganizationId: runtime.activeOrganizationId,
    setOrganization: select, setClient:(id)=>{void selectClient(id);}, session, switching, switchError,
  }}><AccountsExperienceContextProvider value={{ state: { kind: "AUTHENTICATED" }, logout,
    startAuthentication: () => window.location.assign("/auth/login"), selectOrganization: select,
  }}>{children}</AccountsExperienceContextProvider></CustomerRuntimeProvider></BrowserRouter>;
};
